
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "class": "icon",
    "width": "200px",
    "height": "200.00px",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M602.352941 240.941176H150.588235c-33.129412 0-60.235294 27.105882-60.235294 60.235295v421.647058c0 33.129412 27.105882 60.235294 60.235294 60.235295h102.4L662.588235 373.458824V301.176471c0-33.129412-27.105882-60.235294-60.235294-60.235295z m0 542.117648c33.129412 0 60.235294-27.105882 60.235294-60.235295v-252.988235L349.364706 783.058824H602.352941z m271.058824-472.847059l-144.564706 93.364706-6.02353 6.023529v207.811765l150.588236 99.388235c24.094118 15.058824 60.235294 9.035294 60.235294-30.117647V340.329412c0-57.223529-51.2-36.141176-60.235294-30.117647z",
        "fill": "#C7D4E8"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M834.258824 159.623529c-12.047059-12.047059-30.117647-12.047059-42.164706 0l-662.588236 662.588236c-9.035294 12.047059-6.023529 33.129412 6.02353 42.164706 12.047059 9.035294 24.094118 9.035294 36.141176 0l662.588236-662.588236c12.047059-9.035294 12.047059-30.117647 0-42.164706z",
        "fill": "#F45B5B"
      }
    }
  ]
})
    }
  